import { Pipe, PipeTransform } from '@angular/core';
import { PipeFunctions } from './_pipe.functions';

@Pipe({
    name: 'formatMoney',
    standalone: false
})
export class MoneyTranformationPipe implements PipeTransform {

    transform(raw: any): string {
        const n = Number(raw);
        return n.formatMoney(2, 3, '.', ',') + ' €';
    }

}

@Pipe({
    name: 'correctAndFormatMoney',
    standalone: false
})
export class MoneyCorrectionTranformationPipe implements PipeTransform {

    transform(raw: any): string {
        if (!raw) {
            return raw;
        }

        let b = raw;

        if (raw.replace) {
            b = raw.replace(/\./g, '').replace(',', '.');
        }

        const n = Number(b);

        return n.formatMoney(2, 3, '.', ',') + ' €';
    }

}

@Pipe({
    name: 'calcPercent',
    standalone: false
})
export class PercentCalculatePipe implements PipeTransform {

    transform(divident: number, divisor: number): string {
        if (!divident || !divisor) {
            return '0%';
        }

        let res = divident * 100 / divisor;

        if (res > 100) {
            res = 100;
        } else if (res < 0) {
            res = 0;
        }

        return res.formatMoney(0, 3, '.', ',') + '%';
    }

}

@Pipe({
    name: 'formatPercent',
    standalone: false
})
export class PercentFormatPipe implements PipeTransform {

    transform(raw: number): string {
        return PipeFunctions.formatPercent(raw.toString(10));
    }

}
